"use client";
import React from 'react';
import CollectionsPage from "./CollectionsPage";

const Books = () => {
  return <CollectionsPage documentId={'nmk3nLpQE89dMRzzN'} />
};

export default Books;



